import React from 'react';
import styled from 'styled-components/macro';
import Column from './Column';
import Table from './Table';
import DateText, { DateDisplayFormat } from './DateText';
import FormBox from './FormBox';
import Row from './Row';
import { PayoutReportDataRow } from '../api/PayoutReportEndpoints';

export interface EopPayoutsReportProps {
  date: Date;
  data: PayoutReportDataRow[];
}

const EopPayoutsReport: React.FC<EopPayoutsReportProps> = props => {
  const { data, date, ...next } = props;

  return (
    <FormBox {...next} title="EOP Payouts Report">
      <InsetBox>
        <PageTitle>Payouts Report</PageTitle>
        <PayoutsTable
          headers={[
            'shift date',
            'shift',
            'Store_Name',
            'Payouts',
            'Payouts Comments',
          ]}
        >
          {data.map((row, i) => (
            <tr key={i}>
              <td>
                <DateText date={new Date(row.shiftDate)} />
              </td>
              <td>{row.shift}</td>
              <td>{row.storeName}</td>
              <td>{row.payouts}</td>
              <td>{row.payoutComments}</td>
            </tr>
          ))}
        </PayoutsTable>
        <Footer>
          <DateText format={DateDisplayFormat.Long} date={date} />
        </Footer>
      </InsetBox>
    </FormBox>
  );
};

export default styled(EopPayoutsReport)`
  margin: auto;
  width: 700px;
  background: #aaa;
`;

const PageTitle = styled('h1')`
  text-align: left;
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: normal;
`;

const InsetBox = styled(Column)`
  background: #fff;
  box-shadow: 2px 2px black;
  border: 1px solid black;
  font-size: 12px;
  min-height: 600px;
  padding: 20px 30px;
  justify-content: flex-start;
`;

const PayoutsTable = styled(Table)`
  width: 400px;
  margin: 0px 0 0 5px;
  td,
  th {
    background-color: white;
    text-align: left;

    &:nth-child(even) {
      text-align: right;
      padding-right: 15px;
    }
  }

  th {
    &:nth-child(1) {
      text-align: center;
    }
  }
`;

const Footer = styled(Row)`
  margin-top: auto;
  border-top: 1px solid black;
  padding-top: 15px;
  width: 100%;
  padding-right: 40px;
`;
